import { render, staticRenderFns } from "./AttachedRequiredDocument.vue?vue&type=template&id=5548ddd2&"
import script from "./AttachedRequiredDocument.vue?vue&type=script&lang=js&"
export * from "./AttachedRequiredDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports